import { render, staticRenderFns } from "./searchRes.vue?vue&type=template&id=5c01e545&scoped=true&"
import script from "./searchRes.vue?vue&type=script&lang=js&"
export * from "./searchRes.vue?vue&type=script&lang=js&"
import style0 from "./searchRes.vue?vue&type=style&index=0&id=5c01e545&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c01e545",
  null
  
)

export default component.exports